import React from 'react';
import ProfileArea from '../../../components/profile/Profile/Profile';

const Profile = () => {
  return (
    <div className="bg-main" style={{ minHeight: "100vh", width: "100%", overflowX: "hidden" }}>
      <main>
        <ProfileArea />
      </main>
    </div>
  );
};

export default Profile;